export default __webpack_public_path__ + "static/media/251031.b1c9df2b.png";